import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Output } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  confirmModal: ModalOptions;
  confirmOnExit: boolean;
  hideModal: boolean;
  @Output() closeConfirmModal: EventEmitter<boolean> = new EventEmitter();
  
  constructor() {
    this.confirmOnExit = false;
    this.hideModal = false;
    this.confirmModal = new ModalOptions({
      additionalClasses:
        'modal-medium modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'confirmModal',
      modalName: 'confirm_Modal',
    });
   }

  onCancel() {
    this.hideModalAction(true);
  }
  onExit() {
    this.hideModalAction(true);
    location.href = 'https://www.mapfreinsurance.com/';
  }

  hideModalAction(event): void {
    void event;
    this.hideModal = !this.hideModal;
    this.closeConfirmModal.emit(true);
  }

  hideOnClick(event): void {
    if (!event.target.closest(".modal-body")) {
      this.hideModalAction(event);
    }
  }

}
